
// function applyScript() {
//     var boldOptionTitles = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value_title');

//     boldOptionTitles.forEach(function (titleElement) {
//         var titleText = titleElement.textContent.trim();

//       if(titleText.includes('Font Futura PT Light')){
//         titleElement.classList.add('futuramediumbt');
//       }
//       if(titleText.includes('Font Bangers')){
//          titleElement.classList.add('BangersRegular');
//       }
//       if(titleText.includes('Font Courgette')){
//          titleElement.classList.add('Courgette');
//       }
//         if(titleText.includes('Font Alex Brush')){
//          titleElement.classList.add('AlexBrushRegular');
//       }
//          if(titleText.includes('Font Amatic SC')){
//          titleElement.classList.add('AmaticSC-Regular');
//       }
//            if(titleText.includes('Font Smooch')){
//          titleElement.classList.add('Smooch');
//       }
      
      
       
//     });
//   var inputElement = document.querySelector('.bold_option_textbox input').classList.value;
 
//    // Add event listener for radio input changes
//     document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value input[type="checkbox"]').forEach(function (radio) {
//         radio.addEventListener('change', function () {
//           var newClass = this.closest('.bold_option_value').querySelector('.bold_option_value_title').classList.value;
//           // Set the class of the input element
//           // document.querySelector('.bold_option_textbox input').className =  inputElement +' '+ newClass;
//            document.querySelector('#displayTextBold').className = newClass;
//         });
//     });
    

// }

// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function(){
//     document.querySelectorAll('.bold_option.bold_option_checkbox .bold_option_element input[type="checkbox"]').forEach(function (checkbox) {
//       checkbox.addEventListener('change', function () {
//          var titleChecked = this.closest('.bold_option_checkbox').querySelector('.bold_option_title').textContent.trim();
//          if(titleChecked.includes('add custom engraving')){
//         console.log("RADIO CHANGE", titleChecked);
           
//           applyScript();
//          } else {
//         console.log("RADIO CHANGE elseeee", titleChecked);
           
//          }
//       })
//     })
      
    
//   },200)
// });
$(document).ready(function() {
    console.log("--- BOLD CUSTOM JS INIT (DEBUG VERSION) ---");

    // 1. Text input updates
    $('body').on('input', 'input[name*="Add text"], input[name*="Tekst za gravuru"], input[name*="Tekst za gravuro"]', function() {
        var val = $(this).val().trim();
        console.log("[TEXT INPUT] Value changed to:", val);
        
        // Target ALL elements with this ID in case Bold duplicated it
        $('[id="displayTextBold"]').text(val);
    });

    // 2. Helper function to map text to font class
    function getFontClass(fontName) {
        if (fontName.includes('Futura')) return 'futuramediumbt';
        if (fontName.includes('Bangers')) return 'BangersRegular';
        if (fontName.includes('Courgette')) return 'Courgette';
        if (fontName.includes('Alex Brush')) return 'AlexBrushRegular';
        if (fontName.includes('Amatic SC')) return 'AmaticSC-Regular';
        if (fontName.includes('Smooch')) return 'Smooch';
        return '';
    }

    // 3. Core function to apply the font
    function applyFontToPreview(fontClass, triggerSource) {
        console.log(`[APPLY FONT] Triggered by: ${triggerSource}. Attempting to apply class: '${fontClass}'`);
        
        // Find ALL instances of the preview box
        var $previewElements = $('[id="displayTextBold"]');
        
        console.log(`[APPLY FONT] Found ${$previewElements.length} preview element(s) on the page.`);
        
        if ($previewElements.length === 0) {
            console.error("[APPLY FONT ERROR] Could not find the preview box element!");
            return;
        }

        $previewElements.each(function(index) {
            var currentClasses = $(this).attr('class') || "none";
            console.log(`[APPLY FONT - Box ${index + 1}] Classes BEFORE change:`, currentClasses);
            
            // Remove old font classes
            $(this).removeClass('futuramediumbt BangersRegular Courgette AlexBrushRegular AmaticSC-Regular Smooch');
            
            // Add new font class
            if (fontClass) {
                $(this).addClass(fontClass);
            }
            
            var newClasses = $(this).attr('class') || "none";
            console.log(`[APPLY FONT - Box ${index + 1}] Classes AFTER change:`, newClasses);
        });
    }

    // 4. Click listener directly on the label to avoid Bold interfering with checkboxes
    $('body').on('click', '.bold_option_swatch label', function(e) {
        console.log("[SWATCH CLICK] User clicked a font swatch.");
        
        // Find the text inside the title span
        var fontName = $(this).find('.bold_option_value_title').text().trim();
        console.log("[SWATCH CLICK] Extracted font name from label:", fontName);
        
        // Fallback: If text is empty, check the hidden input value
        if (!fontName) {
            fontName = $(this).find('input[type="checkbox"]').val() || "";
            console.log("[SWATCH CLICK] Fallback: Extracted font name from input value:", fontName);
        }

        var mappedClass = getFontClass(fontName);
        
        if (mappedClass) {
            applyFontToPreview(mappedClass, "User Click");
        } else {
            console.warn("[SWATCH CLICK WARNING] Could not map the extracted font name to a CSS class. Name was:", fontName);
        }
    });

    // 5. Initial check on page load for pre-selected options
    console.log("[INIT] Starting interval to check for pre-selected fonts...");
    var initCounter = 0;
    var initInterval = setInterval(function() {
        var $selectedSwatch = $('.bold_swatch_selected');
        
        if ($selectedSwatch.length > 0) {
            console.log("[INIT] Found pre-selected font on load.");
            var fontName = $selectedSwatch.closest('label').find('.bold_option_value_title').text().trim();
            if (!fontName) {
                fontName = $selectedSwatch.find('input[type="checkbox"]').val() || "";
            }
            
            var mappedClass = getFontClass(fontName);
            if (mappedClass) {
                applyFontToPreview(mappedClass, "Initial Load Sync");
            }
            clearInterval(initInterval);
        }
        
        initCounter++;
        if (initCounter >= 20) { // Stop checking after 2 seconds
            console.log("[INIT] Interval stopped. No pre-selected font found.");
            clearInterval(initInterval);
        }
    }, 100);
});

// Hide Bold Titles
function hideBoldTitles() {
  const elements = document.querySelectorAll('.bold_option_title');
  let found = false;
  elements.forEach(el => {
    const text = el.textContent.trim();
    if (text === "Preview" || text === "Info:" || text === "Dodatni tekst" || text === "dodaten text") {
      el.style.display = "none";
      found = true;
    }
  });
  return found;
}

const interval = setInterval(() => {
  if (hideBoldTitles()) clearInterval(interval); 
}, 100);